"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDecimal = exports.normalizeDigits = void 0;
const normalizeDigits = (inputValue) => {
    let cleanedValue = inputValue.replace(/,/g, '.').replace(/[^\d.]/g, '');
    const firstDotPosition = cleanedValue.indexOf('.');
    if (firstDotPosition >= 0) {
        const beforeDot = cleanedValue.substring(0, firstDotPosition + 1);
        const afterDot = cleanedValue
            .substring(firstDotPosition + 1)
            .replace(/\./g, '');
        cleanedValue = beforeDot + afterDot;
    }
    if (cleanedValue.length > 1) {
        if (firstDotPosition >= 0) {
            const integerPart = cleanedValue
                .substring(0, firstDotPosition)
                .replace(/^0+/g, '');
            cleanedValue =
                (integerPart || '0') + cleanedValue.substring(firstDotPosition);
        }
        else {
            cleanedValue = cleanedValue.replace(/^0+/g, '') || '0';
        }
    }
    if (cleanedValue.startsWith('.')) {
        cleanedValue = '0' + cleanedValue;
    }
    return cleanedValue;
};
exports.normalizeDigits = normalizeDigits;
const normalizeDecimal = (inputValue, decimalPlaces = 2) => {
    const normalizedValue = (0, exports.normalizeDigits)(inputValue);
    const [integerPart, decimalPart] = normalizedValue.split('.');
    if (decimalPart !== undefined) {
        return `${integerPart}.${decimalPart.substring(0, decimalPlaces)}`;
    }
    return integerPart;
};
exports.normalizeDecimal = normalizeDecimal;
